// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__x0sYR","filesListContainer":"PosDisputesFiles_filesListContainer__3IHNf","filesButton":"PosDisputesFiles_filesButton__3Wdvm"};